<template>
    <el-carousel arrow="always" type="card" :autoplay="false">
        <el-carousel-item v-for="creative in creatives" :key="creative.id">
            <el-button @click="selectCreative(creative.id)" :type="creative.id === selected ? 'success': 'info'" class="select-creative-button" size="mini" round>
                {{ creative.id === selected ? 'Выбран': 'Выбрать' }}
            </el-button>
            <el-image
                class="borderedScreen" width="100%" :src="creative.screen" v-if="creative.screen"
                :preview-src-list="[creative.screen]">
            </el-image>
            <div v-else class="borderedScreen">
                <img class="borderedScreen" :src="creative.media.media" v-if="storyFileType(creative.media.media) === 'photo'">
                <video controls="controls" v-else width="100%">
                    <source :src="creative.media.media" type='video/mp4;'>
                    Тег video не поддерживается вашим браузером.
                </video>
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
    export default {
        name: "creativeCarousel",
        props: [
            'selected', 'creatives'
        ],
        methods: {
            selectCreative(id) {
                this.$emit('onSelectCreative', id);
            },
            storyFileType(file) {
                if (file.indexOf('.png') !== -1 || file.indexOf('.jpg') !== -1) {
                    return 'photo';
                }
                return 'video';
            },
            selectRandomCreative() {
                if (Math.random() < 0.6) {
                    let creative = this.creatives[Math.floor(Math.random() * this.creatives.length)];
                    this.selectCreative(creative.id);
                }
            }
        },
        watch: {
            creatives: {
                handler() {
                    this.selectRandomCreative()
                },
                deep: true
            }
        },
    }
</script>

<style scoped>
    .borderedScreen {
        width: 100%;
    }
    .open-on-screen {
        z-index: 5;
        position: absolute;
        right: 7px;
        top: 7px;
    }
    .select-creative-button {
        z-index: 5;
        position: absolute;
        right: 41px;
        top: 7px;
    }
    div >>> .el-carousel__item--card {
        display: none;
    }
    div >>> .is-in-stage {
        display:inline-block;
    }
</style>
